import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono2 text-xs font-semibold uppercase tracking-[0.22em] ${
      dark ? "text-blue-400" : "text-blue-600"
    }`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-blue-400" : "bg-blue-600"} animate-pulse-dot`} />
    {children}
  </span>
);
